import React from 'react';
import { Link } from 'react-router-dom';
import { getLogoutUrl } from './../../util/helpers';
import Logo from '../../../img/tppayoff/logo.svg';

const initComponent = (flex = window.flex) => {
    function Header() {
        const { session } = flex.getStore().appContext;

        const logoutUrl = getLogoutUrl(flex);
        const logoutLink = (
            <span>
                <Link to={logoutUrl} className="manheim-header__logout-link">
                    Sign Out
                </Link>
            </span>
        );

        function renderProfileIcon(user) {
            const acronym = user.summary
                .split(/\s/)
                .reduce((response, word) => (response += word.slice(0, 1)), '');

            return <div className="manheim-header__profile-icon-container">{acronym}</div>;
        }

        return (
             <header className="manheim-header manheim-header__header">
                 <div className="manheim-header__container">
                     <Link to="/" className="logo">
                         <img src={Logo} />
                     </Link>
                     {session && session.user && (
                         <div className="manheim-header__logout-container">
                             {renderProfileIcon(session.user)}
                             {logoutLink}
                         </div>
                     )}
                 </div>
             </header>
        );
    }
    return Header;
};

module.exports = initComponent;
